module.exports = __webpack_public_path__ + "img/Online restaurants Icon - white.16bb4b15.svg";